// @Steven this T&C page is ready to be connected to the footer nav
import React from "react";
import ContentLayoutFooterNoChartreuse from "../components/Layout/ContentLayoutFooterNoChartreuse";

function TermsConditions() {
  return (
    <ContentLayoutFooterNoChartreuse title="Terms & Conditions">
      <div className="mx-8">
        <br />
        <h2 className="text-2xl">Terms & Conditions</h2>
        <br />
        <h5>
          These terms and conditions (the &quot;Agreement&quot;) govern your use of the
          Raraity website (the &quot;Website&quot;), including any services or products
          available through the Website. The Website is operated by Raraity,
          Inc. (&quot;Raraity,&quot; &quot;we,&quot; or &quot;us&quot;).
          <br />
          <br />
          Please read this Agreement carefully before using the Website. By
          accessing or using the Website, you agree to be bound by this
          Agreement. If you do not agree to the terms of this Agreement, you may
          not use the Website.
          <br />
          <br />
          Intellectual Property | All content on the Website, including without
          limitation, text, graphics, logos, icons, images, artwork, audio
          clips, video clips, software, and other materials on the Website
          (collectively, the &quot;Content&quot;), is the property of Raraity or its
          licensors and is protected by United States and international
          copyright laws. All rights, title, and interest in and to the Website
          and the Content are and will remain the exclusive property of Raraity
          and its licensors.
          <br />
          <br />
          Raraity, Inc. retains all rights to the copyright of any artwork
          created on the site and retains the right to sell unlimited additional
          copies, both digital and physical prints, of all work regardless of
          the user who created it and without consent. Any use of the Content,
          including without limitation, copying, modification, distribution,
          transmission, display, or performance of the Content, is strictly
          prohibited without the express written consent of Raraity or its
          licensors.
          <br />
          <br />
          You acknowledge that the Content is the subject of copyright
          protection and that unauthorized use of the Content may violate
          copyright, trademark, and other laws. You agree not to circumvent,
          disable or otherwise interfere with security-related features of the
          Website or features that prevent or restrict use or copying of any
          Content or enforce limitations on use of the Website or the Content.
          <br />
          <br />
          Use of Website | Subject to your compliance with this Agreement,
          Raraity grants you a limited, non-exclusive, non-transferable,
          non-sublicensable license to access and use the Website for your
          personal and non-commercial use only. You may not use the Website for
          any purpose that is unlawful or prohibited by this Agreement.
          <br />
          <br />
          You agree not to use the Website in any way that could damage,
          disable, overburden, or impair the Website, or interfere with any
          other party&apos;s use and enjoyment of the Website. You may not use any
          data mining, robots, or similar data gathering or extraction methods
          to obtain any Content from the Website.
          <br />
          <br />
          You agree not to upload or transmit any Content that infringes or
          violates any third-party rights, including without limitation, any
          intellectual property rights, or that contains viruses, worms, Trojan
          horses, or other harmful or disruptive components.
          <br />
          <br />
          Purchasing Services and Products | To purchase services or products
          from the Website, you must provide accurate and complete information,
          including without limitation, your name, address, and payment
          information. You represent and warrant that you have the legal right
          to use any payment method(s) utilized in connection with any purchase.
          <br />
          <br />
          Raraity reserves the right to refuse or cancel any order for any
          reason, at any time. If we cancel an order or transaction, we will
          notify you of the cancellation and refund any applicable payment.
          <br />
          <br />
          Privacy and Security | Your use of the Website and any personal
          information you provide is subject to our Privacy Policy, which is
          incorporated into this Agreement by reference. We take reasonable
          measures to protect your personal information, but we cannot guarantee
          the security of your personal information transmitted to the Website.
          <br />
          <br />
          You are responsible for maintaining the confidentiality of your
          account and password and for restricting access to your computer and
          mobile devices, and you agree to accept responsibility for all
          activities that occur under your account or password.
          <br />
          <br />
          Disclaimer of Warranties | The Website and Products are provided on an
          &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; basis without any warranty or
          representation of any kind, whether express, implied, or statutory.
          Raraity makes no representations or warranties of any kind, express or
          implied, as to the operation of the Website or the information,
          Content, or Products included on the Website.
          <br />
          <br />
          To the fullest extent permitted by applicable law, Raraity disclaims
          all warranties, express or implied, including without limitation,
          warranties of merchantability, fitness for a particular purpose, and
          non-infringement. Raraity does not warrant that the Website or the
          Products will be error-free, uninterrupted, or free from viruses or
          other harmful components.
          <br />
          <br />
          Limitation of Liability | In no event shall Raraity, its affiliates,
          or their respective officers, directors, employees, agents, licensors,
          or suppliers be liable for any indirect, consequential, punitive, or
          special damages arising out of or in connection with your use of the
          Website or Products, whether or not Raraity has been advised of the
          possibility of such damages.
          <br />
          <br />
          Raraity&apos;s total liability to you for any and all claims arising out of
          or relating to this Agreement or your use of the Website or Products,
          whether in contract, tort, or otherwise, shall not exceed the amount
          you paid to Raraity for the Products in question.
          <br />
          <br />
          Governing Law and Dispute Resolution | This Agreement shall be
          governed by and construed in accordance with the laws of the State of
          New York, without giving effect to its conflict of laws provisions.
          Any dispute arising out of or in connection with this Agreement or
          your use of the Website or Products shall be resolved by binding
          arbitration in accordance with the rules of the American Arbitration
          Association.
          <br />
          <br />
          Any such arbitration shall be conducted in the English language and
          held in New York. The arbitration award shall be final and binding,
          and may be entered as a judgment in any court of competent
          jurisdiction.
          <br />
          <br />
          Modification and Termination | Raraity reserves the right to modify or
          terminate this Agreement at any time, without notice to you. Your
          continued use of the Website or Products after any such modification
          constitutes your acceptance of the modified terms.
          <br />
          <br />
          If you do not agree to the modified terms, you must stop using the
          Website and Products.
          <br />
          <br />
          Entire Agreement | This Agreement constitutes the entire agreement
          between you and Raraity and supersedes all prior agreements or
          understandings, whether written or oral, relating to your use of the
          Website or Products.
          <br />
          <br />
          Contact Us | If you have any questions or concerns about this
          Agreement, please contact us at terms@raraity.com.
        </h5>
        <br />
      </div>
    </ContentLayoutFooterNoChartreuse>
  );
}

export default TermsConditions;

export async function getStaticProps() {
  return {
    props: { page: "Terms-Conditions" },
  };
}
